import { spacing } from 'ui/theme';
import { MediaLayoutProp } from '../types';
import { Message } from './Message';
import { Filler, MobileBottomBar, MobileContent, MobileLayout, MobileTopBar } from './styles';

export const MobilePreview = ({ mediaLayout }: MediaLayoutProp) => {
  return (
    <MobileLayout>
      <MobileTopBar />
      <MobileContent>
        <Filler maxHeight={spacing.double} />
        <Message mediaLayout={mediaLayout} />
        <Filler flexGrow={2} />
        <Filler />
      </MobileContent>
      <MobileBottomBar />
    </MobileLayout>
  );
};
